<template>
	<div v-if="isShow" class="curtain-up">
		<img src="/static/images/curtain-up/mu0000.jpg" alt="" v-if="current == 0" />
		<img :src="image" alt="" v-for="(image, index) in images" :key="index" v-show="index + 1 == current" />
		<span v-show="showPass" class="pass" @click="end">跳过动画</span>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	data() {
		return {
			isShow: false,
			current: 0,
			images: [],
			total: 122,
			showPass: true
		};
	},
	methods: {
		loadImage(number) {
			let name,
				suffix = '.png',
				key = 'curtain-up-' + number;
			if (number <= 35) {
				suffix = '.jpg';
			}
			if (number < 10) {
				name = 'mu000' + number + suffix;
			} else if (number < 100) {
				name = 'mu00' + number + suffix;
			} else {
				name = 'mu0' + number + suffix;
			}
			let data = localStorage.getItem(key);
			if (data) {
				return Promise.resolve(data);
			} else {
				return axios
					.get('/static/images/curtain-up/' + name, {
						responseType: 'arraybuffer'
					})
					.then(response => {
						return 'data:image/png;base64,' + btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
					})
					.then(data => {
						//localStorage.setItem(key, data);
						return data;
					});
			}
		},
		begin() {
			this.isShow = true;
			this.$loading.show('加载中');
			let promises = [];

			for (let i = 1; i <= this.total; i++) {
				promises.push(this.loadImage(i));
			}
			Promise.all(promises).then(images => {
				this.$loading.hide();
				this.images = images;
				this.count();
			});
		},
		count() {
			if (this.current <= this.total) {
				this.current++;
				setTimeout(this.count, 40);
			} else {
				this.end();
			}
		},
		end() {
			this.showPass = false
			this.$loading.hide();
			this.isShow = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.curtain-up {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 99999;
	img {
		width: 100%;
		height: 100%;
	}
	.pass{
		position: fixed;
		z-index: 99999999;
		bottom: 20px;
		width: 100%;
		text-align: center;
		display: block;
		color: #999;
		font-size: 14px;
	}
}
</style>
